module.exports = __webpack_public_path__ + "static/media/ma-3.d65c2755.svg";